import {
  ShareButtonContainer,
  RecipeBookmarkButton,
  XButton,
  Header,
} from '@hungryroot/rdp';
import { type RDPModalAnalytics } from '../hooks/useRDPModalAnalytics';

interface RDPModalHeaderProps {
  name: string;
  slug: string;
  id: number;
  index: number | null;
  onDismiss: () => void;
  analytics: RDPModalAnalytics;
}

export const RDPModalHeader = ({
  name,
  slug,
  id,
  index,
  onDismiss,
  analytics,
}: RDPModalHeaderProps) => {
  const staticRecipeBookmarkButton = (
    <RecipeBookmarkButton
      pairingId={id}
      pairingName={name}
      size="medium"
      prominence="tertiary"
      style="muted"
      onBookmark={() => analytics.trackBookmark(id, index)}
    />
  );

  const staticShareButton = (
    <ShareButtonContainer
      title={name}
      text={name}
      size="medium"
      prominence="tertiary"
      style="muted"
      url={`${window.location.origin}/recipes/${slug}/`}
      onShareSuccess={() => analytics.handleShare(id, index)}
    />
  );

  const staticXButton = (
    <XButton
      onClick={onDismiss}
      size="medium"
      prominence="tertiary"
      style="muted"
      testid="rdp-modal-scroll-x-button"
    />
  );

  return (
    <Header
      primaryTopIconButton={staticShareButton}
      secondaryTopIconButton={staticRecipeBookmarkButton}
      primaryTopRightIconButton={staticXButton}
    />
  );
};
